$(document).on('turbolinks:load', function() {
  // =====================================================
  // Copy buttons with tooltip feedback
  // Uses delegated event, only triggers on .js-copy-btn elements
  // =====================================================
  $(document).on('click', '.js-copy-btn', function() {
    var $btn = $(this);
    var textToCopy = $btn.data('copy');
    var copyText = $btn.data('copy-text') || 'Copy';
    var copiedText = $btn.data('copied-text') || 'Copied!';

    navigator.clipboard.writeText(textToCopy).then(function() {
      // Dispose and recreate tooltip with new text
      $btn.tooltip('dispose');
      $btn.attr('title', copiedText);
      $btn.tooltip({ trigger: 'manual' });
      $btn.tooltip('show');

      setTimeout(function() {
        $btn.tooltip('dispose');
        $btn.attr('title', copyText);
        $btn.tooltip();
      }, 1500);
    });
  });

  // =====================================================
  // VPS Index page (only if #vps-table exists)
  // =====================================================
  var vpsTable = document.getElementById('vps-table');

  if (vpsTable) {
    // Filtering
    var filterStatus = document.getElementById('filter-status');
    var filterSearch = document.getElementById('filter-search');
    var sortBy = document.getElementById('sort-by');

    function applyFilters() {
      var status = filterStatus ? filterStatus.value : 'all';
      var search = filterSearch ? filterSearch.value.toLowerCase() : '';

      document.querySelectorAll('.vps-row').forEach(function(row) {
        var matchStatus = status === 'all' || row.dataset.status === status;
        var matchSearch = !search ||
          row.dataset.name.includes(search) ||
          (row.dataset.ip && row.dataset.ip.includes(search));

        row.style.display = (matchStatus && matchSearch) ? '' : 'none';
      });
    }

    function sortTable() {
      var tbody = vpsTable.querySelector('tbody');
      var rows = Array.from(tbody.querySelectorAll('.vps-row'));
      var sortField = sortBy.value;

      rows.sort(function(a, b) {
        if (sortField === 'name') {
          return a.dataset.name.localeCompare(b.dataset.name);
        } else if (sortField === 'status') {
          var order = { 'running': 0, 'starting': 1, 'stopping': 2, 'stopped': 3, 'error': 4 };
          return (order[a.dataset.status] || 99) - (order[b.dataset.status] || 99);
        } else if (sortField === 'time_left') {
          return parseInt(a.dataset.daysLeft) - parseInt(b.dataset.daysLeft);
        } else if (sortField === 'disk') {
          return parseInt(b.dataset.disk) - parseInt(a.dataset.disk);
        }
        return 0;
      });

      rows.forEach(function(row) { tbody.appendChild(row); });
    }

    if (filterStatus) filterStatus.addEventListener('change', applyFilters);
    if (filterSearch) filterSearch.addEventListener('input', applyFilters);
    if (sortBy) sortBy.addEventListener('change', sortTable);

    // Bulk selection
    var selectAll = document.getElementById('select-all');
    var checkboxes = document.querySelectorAll('.vps-checkbox');
    var bulkActions = document.getElementById('bulk-actions');
    var selectedCount = document.getElementById('selected-count');

    function updateBulkActions() {
      var checked = document.querySelectorAll('.vps-checkbox:checked');
      var count = checked.length;

      if (count > 0) {
        bulkActions.classList.remove('d-none');
        selectedCount.textContent = count;
      } else {
        bulkActions.classList.add('d-none');
      }
    }

    if (selectAll) {
      selectAll.addEventListener('change', function() {
        var self = this;
        checkboxes.forEach(function(cb) {
          if (!cb.disabled) cb.checked = self.checked;
        });
        updateBulkActions();
      });
    }

    checkboxes.forEach(function(cb) {
      cb.addEventListener('change', updateBulkActions);
    });

    // Inline note editing
    document.querySelectorAll('.inline-note-container').forEach(function(container) {
      var display = container.querySelector('.note-display');
      var edit = container.querySelector('.note-edit');
      var input = container.querySelector('.note-input');
      var saveBtn = container.querySelector('.save-note-btn');
      var cancelBtn = container.querySelector('.cancel-note-btn');
      var vpsId = container.dataset.id;

      display.addEventListener('click', function() {
        display.classList.add('d-none');
        edit.classList.remove('d-none');
        input.focus();
        input.select();
      });

      cancelBtn.addEventListener('click', function() {
        var noteText = container.querySelector('.note-text');
        edit.classList.add('d-none');
        display.classList.remove('d-none');
        input.value = noteText ? noteText.textContent : '';
      });

      saveBtn.addEventListener('click', function() {
        var newNote = input.value.trim();
        // TODO: Save via API
        console.log('Save note for:', vpsId, newNote);

        var noteSpan = display.querySelector('.note-text') || display.querySelector('.note-placeholder');
        if (!noteSpan) {
          noteSpan = document.createElement('span');
          noteSpan.className = 'small text-muted note-text';
          display.innerHTML = '';
          display.appendChild(noteSpan);
        }
        noteSpan.className = newNote ? 'small text-muted note-text' : 'small text-muted note-placeholder';
        noteSpan.textContent = newNote || '—';

        edit.classList.add('d-none');
        display.classList.remove('d-none');
      });

      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          saveBtn.click();
        } else if (e.key === 'Escape') {
          cancelBtn.click();
        }
      });
    });
  }

  // =====================================================
  // VPS Show page (only if #sidebar-nav exists)
  // =====================================================
  var sidebarNav = document.getElementById('sidebar-nav');

  if (sidebarNav) {
    // Section navigation
    var navLinks = sidebarNav.querySelectorAll('a');
    var sections = document.querySelectorAll('.content-section');

    navLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var sectionId = 'section-' + this.dataset.section;

        navLinks.forEach(function(l) { l.classList.remove('active'); });
        this.classList.add('active');

        sections.forEach(function(s) { s.classList.add('d-none'); });
        document.getElementById(sectionId).classList.remove('d-none');
      });
    });

    // Password toggle
    var toggleBtn = document.getElementById('toggle-password');
    var passwordInput = document.getElementById('root-password');

    if (toggleBtn && passwordInput) {
      toggleBtn.addEventListener('click', function() {
        var type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
        passwordInput.setAttribute('type', type);
        var icon = this.querySelector('i');
        if (type === 'text') {
          icon.classList.remove('fa-eye');
          icon.classList.add('fa-eye-slash');
        } else {
          icon.classList.remove('fa-eye-slash');
          icon.classList.add('fa-eye');
        }
      });
    }

    // Delete confirmation
    var deleteInput = document.getElementById('delete-confirm-input');
    var deleteBtn = document.getElementById('delete-confirm-btn');

    if (deleteInput && deleteBtn) {
      deleteInput.addEventListener('input', function() {
        deleteBtn.disabled = this.value !== this.dataset.hostname;
      });
    }
  }
});
